<template>
  <span v-if="result" class="text-normal control-result" :data-qid="'control-result-badge-' + result.value">
    <font-awesome-icon :icon="result.icon" :class="result.cls" class="mr-1"/>{{ $t('tasks.control_result.' + result.value) }}
  </span>
</template>

<script>
import { controlResult } from '@/util/controlResult.js';

// The result of a control or security measure task (US 9478); also reads the pass and fail saved before
export default {
  name: 'ControlResultBadge',
  props: {
    value: { type: String, default: null }
  },
  computed: {
    result() {
      return controlResult(this.value);
    }
  }
}
</script>
